import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  AlertDialog,
  AlertDialogHeader,
  AlertDialogBody,
  Heading,
} from '@americanexpress/dls-react';
import { IconWarning } from '@americanexpress/dls-icons';
import styles from './QuitModal.scss';

const checkIfNullOrUndefined = (value) => value === null || value === undefined;

const getModalTitle = (title, modalTitle) => (
  checkIfNullOrUndefined(title) ? modalTitle : title
);

const getWarningIcon = (warningMessage) => (
  warningMessage ? <IconWarning color="caution" isFilled={true} size="xl" /> : null
);

const QuitModal = ({ modalDetails, languageData }) => {
  const {
    redirectToLandingPage,
    title,
    content,
    continueText,
    exitTextInModal,
    setShow,
    warningMessage,
    handleActionsOnExit = null,
    shouldRedirectOnExit = true,
    continueQuitModalReactlytics,
    exitQuitModalReactlytics,
  } = modalDetails;

  const {
    continueButtonText, exitButtonText, modalTitle, modalBody,
  } = languageData;

  const showContinueButton = Boolean(continueText || continueButtonText);
  const showExitButton = Boolean(exitTextInModal || exitButtonText);

  return (
    <AlertDialog id="navbar-quit-modal" reactlytics={{ disable: true }} aria-labelledby="exitModal">
      <AlertDialogHeader
        id="alert-dialog-header"
        className="pad-3-t"
        icon={getWarningIcon(warningMessage)}
      >
        <Heading level={2} variant="sans-small-bold">
          {getModalTitle(title, modalTitle)}
        </Heading>
      </AlertDialogHeader>
      <AlertDialogBody
        id="alert-dialog-body"
        actionSlot={(
          <>
            {showContinueButton && (
              <Button
                className={`margin-1-t ${styles.cursorPointer}`}
                onClick={() => setShow(false)}
                {...{
                  reactlytics: continueQuitModalReactlytics || {
                    element: 'Continue',
                    detail: 'QuitModal',
                  },
                }}
              >
                {continueText || continueButtonText}
              </Button>
            )}
            {showExitButton && (
              <Button
                variant="secondary"
                className={`${styles.cursorPointer}`}
                onClick={() => {
                  sessionStorage.setItem('isExitBtnClicked', true);
                  if (handleActionsOnExit) {
                    handleActionsOnExit();
                  }
                  if (shouldRedirectOnExit) {
                    redirectToLandingPage();
                  }
                  setShow(false);
                }}
                reactlytics={
                  exitQuitModalReactlytics || {
                    element: 'Leave',
                    detail: 'QuitModal',
                  }
                }
              >
                {exitTextInModal || exitButtonText}
              </Button>
            )}
          </>
        )}
      >
        {warningMessage || (checkIfNullOrUndefined(content) ? modalBody : content)}
      </AlertDialogBody>
    </AlertDialog>
  );
};

QuitModal.propTypes = {
  modalDetails: PropTypes.objectOf(PropTypes.string),
  languageData: PropTypes.objectOf(PropTypes.string),
};

export default QuitModal;
